import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './posthog';

// Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// Tippy.js
import 'tippy.js/dist/tippy.css';

// Tailwind css
import './tailwind.css';

// Mantine
import '@mantine/core/styles.layer.css';
import 'mantine-datatable/styles.layer.css';

// i18n (needs to be bundled)
import './i18n';

// nouislider
import 'nouislider/dist/nouislider.css';

// Mantine datatable
import '@mantine/dates/styles.css';

// Flatpickr
import 'flatpickr/dist/flatpickr.css';

// AOS (Animate On Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';

// Router
import { RouterProvider } from 'react-router-dom';
import router from './router/index';

// Redux
import { Provider } from 'react-redux';
import store, { persistor } from './store/index';
import { PersistGate } from 'redux-persist/integration/react';
import { UserProvider } from './contexts/UserContext';
import { MantineProvider } from '@mantine/core';
import { AuthLoader } from './components/AuthLoader';
import CookieConsentBanner from './components/CookieConsentBanner';

if (import.meta.env.DEV) {
    window.addEventListener('unhandledrejection', (event) => {
        if (event.reason?.message?.includes('INTERNAL ASSERTION FAILED')) {
            console.warn('Suppressed a known Firestore emulator race condition:', event.reason.message);
            event.preventDefault();
        }
    });
}

try {
    // Initialize AOS
    AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
        once: true,
        mirror: false,
    });

    Sentry.init({
        dsn: "https://2b8218a7b8aac82b17d86befae18aa16@o4510256055517184.ingest.us.sentry.io/4510744542314496",
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Session Replay was often the cause of WebView crashes/errors on iOS, keeping disabled for now
            // Sentry.replayIntegration()
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["localhost", /^https:\/\/sentola\.ru\/api/],
        // replaysSessionSampleRate: 0.1,
        // replaysOnErrorSampleRate: 1.0,
    });

    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
        <React.StrictMode>
            <Suspense>
                <Provider store={store}>
                    <PersistGate loading={<AuthLoader />} persistor={persistor}>
                        <MantineProvider>
                            <UserProvider>
                                <RouterProvider router={router} />
                            </UserProvider>
                        </MantineProvider>
                    </PersistGate>
                </Provider>
            </Suspense>
            <Suspense fallback={null}>
                <CookieConsentBanner />
            </Suspense>
        </React.StrictMode>
    );
} catch (e: any) {
    console.error("React mount error: ", e);
}
